import LoraStatusPage from '@/views/lora/LoraStatus.vue';
import LoraSettingsPage from '@/views/lora/LoraSettings.vue';
import LoraForwarderPage from '@/views/lora/LoraForwarderPage.vue';

export default class LoraRoutes {
  public static Routes = [
    {
      path: 'status',
      name: 'lora-status',
      component: LoraStatusPage,
      meta: {
        label: 'Status',
      },
    },
    {
      path: 'forwarder',
      name: 'lora-forwarder',
      component: LoraForwarderPage,
      meta: {
        label: 'Forwarder',
      },
    },
    {
      path: 'settings',
      name: 'lora-settings',
      component: LoraSettingsPage,
      meta: {
        label: 'Settings',
      },
    },
  ];
}
